<div class="app-header new-header">
	<mat-toolbar id="toolbar-lg">
		<mat-toolbar-row class="banner" style="padding: 0; flex-direction: column">
			<div class="log-row d-flex justify-content-between align-items-center">
				<div class="logo">
					<span class="logo-container">
						<img class="logo logo-lg" src="assets/images/brand.png" routerLink="/" />
						<img class="logo logo-md" src="assets/images/brand.png" routerLink="/" />
					</span>
				</div>
				<div class="header-links">
					<div class="links">
						<span fxFlex class="department">

							<a mat-button routerLink="/service-catalog" routerLinkActive="active">{{
								'NAV.SERVICES_CATALOG' | translate
								}}</a>

							<a mat-button [matMenuTriggerFor]="afterMenu"
								*ngIf="showDashboardCounters && loggedIn; else myRequestsContainer">{{ 'NAV.MENULIST' |
								translate }}</a>
							<mat-menu #afterMenu="matMenu" xPosition="after">
								<button mat-menu-item *ngIf="loggedIn" routerLink="/requests/my"
									routerLinkActive="active">
									{{ 'NAV.MY_REQUESTS' | translate }}
								</button>

								<button mat-menu-item *ngIf="loggedIn" [routerLink]="['/requests/myTasks', { u: 1 }]"
									routerLinkActive="active">
									{{ 'NAV.MY_TASKS' | translate }}
								</button>
							</mat-menu>

							<ng-template #myRequestsContainer>
								<a mat-button *ngIf="loggedIn" routerLink="/requests/my" routerLinkActive="active">{{
									'NAV.MY_REQUESTS' | translate
									}}</a>
								<a mat-button *ngIf="!loggedIn" routerLink="/requests/query"
									routerLinkActive="active">{{ 'NAV.QUERY_REQUEST' | translate }}</a>
							</ng-template>
						</span>
					</div>
					<ul class="user-assets">
						<li>
							<div *ngIf="loggedIn" class="user-container" mat-button [matMenuTriggerFor]="menu">
								<span class="user-photo">
									<img [src]="
											userDetails?.photo
												? userDetails?.photo
												: configService.userAvatar
												? configService.userAvatar
												: 'assets/images/icons/bx-user-circle.svg'
										" [alt]="userDetails?.firstName" class="photo" />
								</span>
							</div>
							<div *ngIf="!loggedIn" (click)="login()" class="identity">
								{{ 'LAYOUT.LOGIN' | translate }}
							</div>
						</li>
						<li>
							<a class="phone-ico" href="tel:920033555">
								<svg xmlns="http://www.w3.org/2000/svg" width="25.969" height="25.669"
									viewBox="0 0 25.969 25.669">
									<path id="Path_8127" data-name="Path 8127"
										d="M532.931,236.628a1.377,1.377,0,0,0-1.931,0h0l-2.179,2.153a10.267,10.267,0,0,1-4.088-2.153,10.07,10.07,0,0,1-2.179-4.041l2.179-2.153a1.339,1.339,0,0,0,0-1.908h0l-5.466-5.4a1.377,1.377,0,0,0-1.93,0h0l-3.707,3.663a2.686,2.686,0,0,0-.8,1.938A20.544,20.544,0,0,0,518.7,242.59a21.048,21.048,0,0,0,14.032,5.805h.038a2.715,2.715,0,0,0,1.92-.791l3.706-3.663a1.339,1.339,0,0,0,0-1.908h0l-5.466-5.4Zm-.174,9.065a18.191,18.191,0,0,1-12.124-5.013,17.773,17.773,0,0,1-5.072-11.985l2.739-2.706,3.533,3.492-1.766,1.746a1.339,1.339,0,0,0-.372,1.232,13.654,13.654,0,0,0,3.1,6.079,13.96,13.96,0,0,0,6.151,3.067,1.364,1.364,0,0,0,1.246-.366l1.769-1.746,3.533,3.493Z"
										transform="translate(-512.828 -222.727)" fill="#4c3d8f" />
								</svg>
							</a>
						</li>
						<li class="lang-li">
							<button mat-menu-item *ngIf="switchLangService.currentLang == 'en'"
								(click)="switchLangService.changeLang('ar')">
								ع
							</button>
							<button mat-menu-item *ngIf="switchLangService.currentLang == 'ar'"
								(click)="switchLangService.changeLang('en')">
								En
							</button>

						</li>
					</ul>
				</div>
			</div>

			<div class="log-row d-flex align-items-center overflow-auto mt-3">
				<ng-container *ngFor="let menuItem of menuItems">
					<ng-container *appHasRole="menuItem.permissions; roleResource: menuItem.title; roleEnv: false">
						<div class="subHeaderItem">
							<a [routerLink]="menuItem.path" routerLinkActive="active" [routerLinkActive]="['selected']"
								class="menu-item d-flex align-items-center">
								<i *ngIf="!menuItem.icon.startsWith('fa')" class="pi item-icon"
									[ngClass]="'boi-' + menuItem.icon"></i>
								<i *ngIf="menuItem.icon.startsWith('fa')" class="item-icon fa {{ menuItem.icon }}"></i>
								<span class="item-title">{{ menuItem.title | translate }}</span>
							</a>
						</div>
					</ng-container>
				</ng-container>
			</div>

			<mat-menu #menu="matMenu">
				<button class="user-details sm" mat-menu-item routerLink="/accounts/my-profile" *ngIf="loggedIn">
					<span>{{ 'LAYOUT.WELCOME' | translate }}</span>
					<span> {{ userDetails?.firstName }} {{ userDetails?.lastName }} </span>
				</button>
				<button mat-menu-item routerLink="/accounts/entity/profile" *ngIf="loggedIn">
					<ng-container *ngIf="type == 'facilityInformation'; else normal">
						{{ 'LAYOUT.FACILITY_PROFILE' | translate }}
					</ng-container>
					<ng-template #normal>
						{{ 'LAYOUT.PROFILE' | translate }}
					</ng-template>
				</button>
				<button mat-menu-item (click)="logout()" *ngIf="loggedIn">
					{{ 'LAYOUT.LOGOUT' | translate }}
				</button>
				<button mat-menu-item (click)="login()" *ngIf="!loggedIn">
					{{ 'LAYOUT.LOGIN' | translate }}
				</button>
			</mat-menu>
		</mat-toolbar-row>
	</mat-toolbar>
</div>